import { errorHandler } from '../common';
import Api from '../api';

const { axios: api } = Api;

export const getLeadOrdersDashboard = () =>
	errorHandler(async () => {
		const data = await api.get(`/report/lead-orders-dashboard`);
		return { data: data.data };
	});

export const createLeadOrder = (payload) =>
	errorHandler(async () => {
		const data = await api.post(`/lead-order`, payload);
		return { data: data.data };
	});
